import { useState } from "react";
import { Filter, PropertyFilter } from "../types/types";
import useStateFromQuery from "./useStateFromQuery";
import { DataTableState } from "../components/UI/DataTable/DataTable";

export enum FilterType {
	PATTERN,
	VALUES,
	RANGE,
	DATE_RANGE,
}

export interface UsePropertyFilters {
	filters: (Filter | PropertyFilter)[];
	addFilter: (filter: Filter | PropertyFilter) => void;
	updateFilterAt: (index: number, state: Filter | PropertyFilter) => void;
	removeFilterAt: (index: number) => void;
	clearFilters: () => void;
}

export default function usePropertyFilters(): UsePropertyFilters {
	const state = useStateFromQuery<DataTableState>();
	const initialState = state && "filters" in state && state.filters ? state.filters : [];
	const [filters, setFilters] = useState<(Filter | PropertyFilter)[]>(initialState);

	const addFilter = (filter: Filter | PropertyFilter) => {
		const updated = [...filters, filter];

		setFilters(updated);
	};

	const updateFilterAt = (index: number, state: Filter | PropertyFilter) => {
		setFilters((prev) => {
			const updated = [...prev];
			updated.splice(index, 1, state);
			return updated;
		});
	};

	const removeFilterAt = (index: number) => {
		setFilters((prev) => {
			const updated = [...prev];
			updated.splice(index, 1);
			return updated;
		});
	};

	const clearFilters = () => setFilters([]);

	return {
		filters,
		addFilter,
		updateFilterAt,
		removeFilterAt,
		clearFilters,
	};
}
